import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectOne } from "../../store/project/actions";
export var GetProjectOne = function (trigger, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseOneProject: (_a = state.Project.responseOneProject) === null || _a === void 0 ? void 0 : _a.data,
            errorOneProject: state.Project.errorOneProject,
            loadingOneProject: state.Project.loadingOneProject,
        });
    }), responseOneProject = _a.responseOneProject, errorOneProject = _a.errorOneProject, loadingOneProject = _a.loadingOneProject;
    useEffect(function () {
        if (trigger) {
            dispatch(projectOne({
                id: id,
            }));
        }
    }, [trigger, id]);
    return {
        responseOneProject: responseOneProject,
        errorOneProject: errorOneProject,
        loadingOneProject: loadingOneProject,
    };
};
